var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5C5.5 4.5 2.23 8.11 1.2 9.56C1.07 9.74 1 9.96 1 10.18C1 10.41 1.07 10.62 1.2 10.81C2.23 12.26 5.5 15.5 10 15.5C14.5 15.5 17.77 12.26 18.8 10.81C18.93 10.62 19 10.41 19 10.18C19 9.96 18.93 9.74 18.8 9.56C17.77 8.11 14.5 4.5 10 4.5Z",
    stroke: "#9F9F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3,
    stroke: "#9F9F9F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.41bf99c3b17da37cb0a33a5eabdc2cf7.svg";
export { ForwardRef as ReactComponent };